import { useQuery } from '@tanstack/react-query';
import { billingApi } from '@/shared/api';

/** Fetches current subscription info. */
export function useSubscription() {
  return useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: billingApi.getSubscription,
  });
}

/** Fetches payment history. */
export function usePayments() {
  return useQuery({
    queryKey: ['billing', 'payments'],
    queryFn: billingApi.getPayments,
  });
}

/** Fetches current resource usage. */
export function useResourceUsage() {
  return useQuery({
    queryKey: ['billing', 'usage'],
    queryFn: billingApi.getResourceUsage,
  });
}
